export default __webpack_public_path__ + "static/media/Dubai-Regular.85c066d5.woff";